import { render, staticRenderFns } from "./ModalPrivacyPolicy.vue?vue&type=template&id=694694d1&"
import script from "./ModalPrivacyPolicy.vue?vue&type=script&lang=js&"
export * from "./ModalPrivacyPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('694694d1')) {
      api.createRecord('694694d1', component.options)
    } else {
      api.reload('694694d1', component.options)
    }
    module.hot.accept("./ModalPrivacyPolicy.vue?vue&type=template&id=694694d1&", function () {
      api.rerender('694694d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Terms/Modal/ModalPrivacyPolicy.vue"
export default component.exports